﻿import { DataRequest } from 'shared/data/datarequest';

export class FieldDataUpdate extends DataRequest {
    static $type = 'Web.FieldDataUpdate';

    identifier: string;
    fieldName: string;
    value: any;

    static create(identifier: string, fieldName: string, value: any) {
        var x = new FieldDataUpdate();

        x.$type = FieldDataUpdate.$type;

        x.identifier = identifier;
        x.fieldName = fieldName;
        x.value = value;

        return x;
    }
}